import styled from "styled-components";

const SchedulingApprovalWrapper = styled.div`
  .ant-table-tbody > tr.ant-table-row-selected > td {
    background: rgb(255 251 240);
  }
  .ant-table-tbody > tr.ant-table-row-selected:hover {
    td {
      background: rgb(255 251 240);
    }
  }
  .ant-table {
    .main_title td {
      background-color: #e7e6ff !important;
      padding: 5px 0;
      border-color: #e7e6ff !important;
      span {
        color: #584feb;
        font-weight: 600;
      }
    }
    .week_number_row td {
      // background-color: #e7e6ff !important;
      padding: 5px 0;
      border-color: #e7e6ff !important;
      span {
        color: #000000;
        font-weight: 600;
      }
    }
  }
  .edit-mode {
    .ant-picker,
    .ant-select-selector {
      background-color: #546e7a !important;
      input,
      span {
        color: #ffffff !important;
      }
    }
    .ant-select-arrow {
      display: none;
    }
  }
  .ant-table-footer {
    background: #ffffff;
  }

  .timewatch-events-container {
    width: 320px;
    margin: 0 10px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
  }

  .timewatch-events-container:hover {
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }

  .ant-table-title {
    padding: 0 !important;
  }

  .timewatch-events-title {
    font-size: 14px;
    font-weight: 600;
    color: #5850ec;
    text-align: center;
    padding: 12px 0;
    background-color: #f0f1fe;
    border-bottom: 1px solid #e8eaff;
  }

  .timewatch-events-date {
    display: block;
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
  }

  .timewatch-event-row {
    transition: background-color 0.3s ease;
  }

  .timewatch-event-row:hover {
    background-color: #f3f4ff !important;
  }

  .timewatch-event-row.even {
    background-color: #ffffff;
  }

  .timewatch-event-row.odd {
    background-color: #fafbff;
  }

  .timewatch-events-container .ant-table-thead > tr > th {
    background-color: #f0f1fe;
    color: #5850ec;
    font-weight: 600;
  }

  .timewatch-events-container .ant-table-tbody > tr > td {
    border-bottom: 1px solid #e5e7eb;
  }
`;

export default SchedulingApprovalWrapper;
